import React from 'react';

function MainLayout({ children }) {
  return (
    <div style={{ minHeight: '100vh', background: '#060c16', color: '#fff' }}>
      <main style={{ width: '100%', boxSizing: 'border-box' }}>{children}</main>
    </div>
  );
}

export default MainLayout;
